import { useState } from "react";
import AppEmptyState from "../../../../elements/AppEmptyState";
import CreateTableLayoutDrawer, {
  LayoutTypes,
} from "../../../TableLayouts/CreateTableLayoutDrawer";
import { useParams } from "react-router-dom";

import { Module } from "../../../../types/TenantInterfaces";
import useUpdateView from "../../../../api/api-hooks/views/useUpdateView";
import usePageViewTable from "../usePageViewTable";
import { layoutTypeMap } from "../../../TableLayouts/TableLayoutsButton";
import { SharedViewModes } from "../../PageViewRenderer";

/**
 * NoCardsLayouts - Handles the case where the user has no "Cards" layouts.
 */
function NoCardsLayouts({
  viewMode,
  currentModule,
  viewID,
  parentViewID,
}: {
  viewMode: SharedViewModes;
  currentModule: Module;
  viewID: string;
  parentViewID?: string;
}) {
  const { pageID }: any = useParams();
  const [createDrawerOpen, setCreateDrawerOpen] = useState(false);
  const { updateView, viewUpdating } = useUpdateView(pageID);
  const { createItem } = usePageViewTable({
    currentViewID: viewID,
    updateView,
    parentViewID,
  });
  const layoutInfo = layoutTypeMap[viewMode as SharedViewModes];

  return (
    <>
      <AppEmptyState
        className="ml--2 mr-2"
        title="No Layouts!"
        description={`There are no layouts defined for your ${
          viewMode as SharedViewModes
        }. Get started by creating a layout.`}
        buttonTitle={"Create Layout"}
        onClick={() => setCreateDrawerOpen(true)}
      />
      <CreateTableLayoutDrawer
        open={createDrawerOpen}
        submitting={viewUpdating}
        onClose={() => setCreateDrawerOpen(false)}
        currentModule={currentModule}
        handleCreate={createItem}
        updateKey={layoutInfo.itemKey as LayoutTypes}
        title={viewMode as SharedViewModes}
        limit={6}
        fieldSchema={undefined}
        handleUpdate={undefined}
      />
    </>
  );
}

export default NoCardsLayouts;
